// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5590) return "static/chunks/5590.282c46b99c1a2b5d.js";
	if (chunkId === 5449) return "static/chunks/a6d7571c.9b72910619b6f59d.js";
	if (chunkId === 2173) return "static/chunks/2173.e684a63c081de432.js";
	if (chunkId === 9835) return "static/chunks/9835.cb297957e7c22ccc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1474":"a27462dba6f8347a","2307":"2959eeadfb5c7d03","2537":"8819a2fa380c36e6","3306":"994fc6d13c615c2b","7396":"dee8253073aa4153","8935":"e83e512ef2648431","9541":"01830a7914ef5c9e"}[chunkId] + ".js";
};